import { render, staticRenderFns } from "./WeTeach.vue?vue&type=template&id=10857306&scoped=true&"
import script from "./WeTeach.vue?vue&type=script&lang=js&"
export * from "./WeTeach.vue?vue&type=script&lang=js&"
import style0 from "./WeTeach.vue?vue&type=style&index=0&id=10857306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10857306",
  null
  
)

export default component.exports